"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenceResolveValidation = void 0;
var journey_services_1 = require("@athena-portal/journey-services");
var DrivingLicenceResolveValidation = /** @class */ (function (_super) {
    __extends(DrivingLicenceResolveValidation, _super);
    function DrivingLicenceResolveValidation(props) {
        var _this = _super.call(this) || this;
        _this.props = props;
        if ((!_this.props.licenceID)) {
            throw Error("drivingLicenceResolve validation missing 'licenceID' setting");
        }
        return _this;
    }
    DrivingLicenceResolveValidation.prototype.validateInput = function (input, context) {
        var _a, _b, _c, _d, _e;
        var pageContext = context;
        if (pageContext.engine) {
            var journeyState = pageContext.engine.getJourneyState();
            var isDriverLicenseHandy = this.props.driverIndex ? pageContext.engine.getInteraction().additionalDrivers[this.props.driverIndex].drivingLicenceHandy : true;
            var videoStreamEnabled = journeyState.videoStreamEnabled;
            var frontResolved = journeyState["".concat(this.props.licenceID, "DLFrontResolved")];
            var frontIsUKType = journeyState["".concat(this.props.licenceID, "DLFrontIsUKType")];
            var duplicateFound = isDriverLicenseHandy ? journeyState["".concat(this.props.licenceID, "DuplicateDriverFound")] : false;
            var licenceNotResolved = journeyState["".concat(this.props.licenceID, "LicenceNotResolved")];
            var imageExtensionIsCorrect = journeyState["".concat(this.props.licenceID, "ImageExtensionIsCorrect")];
            if (videoStreamEnabled !== undefined && !videoStreamEnabled) {
                var error = this.getErrorMessage(context, "We can’t access your camera! To prevent you having to enter your " +
                    "driving licence details manually, please give us access to use your camera in settings.");
                return this.invalidResult(error);
            }
            if (imageExtensionIsCorrect !== undefined && !imageExtensionIsCorrect) {
                var error = this.getErrorMessage(context, "Incorrect image extension, you can upload only JPG, PNG, BMP and GIF images.");
                pageContext.engine.setJourneyState((_a = {},
                    _a["".concat(this.props.licenceID, "ImageExtensionIsCorrect")] = true,
                    _a));
                return this.invalidResult(error);
            }
            else if (frontIsUKType !== undefined && frontIsUKType != null && !frontIsUKType) {
                var error = this.getErrorMessage(context, "We can’t insure drivers with non-UK driving licence. Please upload UK driving licence");
                pageContext.engine.setJourneyState((_b = {},
                    _b["".concat(this.props.licenceID, "DLFrontIsUKType")] = true,
                    _b));
                return this.invalidResult(error);
            }
            else if (frontResolved !== undefined && frontResolved != null && !frontResolved) {
                var error = this.getErrorMessage(context, "Please upload front of the driving licence.");
                pageContext.engine.setJourneyState((_c = {},
                    _c["".concat(this.props.licenceID, "DLFrontResolved")] = true,
                    _c["".concat(this.props.licenceID, "DLFrontIsUKType")] = true,
                    _c));
                return this.invalidResult(error);
            }
            else if (duplicateFound !== undefined && duplicateFound) {
                var error = this.getErrorMessage(context, "This driving licence has been used already. Please upload a different licence.");
                pageContext.engine.setJourneyState((_d = {},
                    _d["".concat(this.props.licenceID, "DuplicateDriverFound")] = false,
                    _d));
                return this.invalidResult(error);
            }
            else if (licenceNotResolved !== undefined && licenceNotResolved) {
                var error = this.getErrorMessage(context, "Please upload correct driver licence");
                pageContext.engine.setJourneyState((_e = {},
                    _e["".concat(this.props.licenceID, "LicenceNotResolved")] = true,
                    _e));
                return this.invalidResult(error);
            }
        }
        return this.validResult();
    };
    return DrivingLicenceResolveValidation;
}(journey_services_1.ValidationMethodBase));
exports.DrivingLicenceResolveValidation = DrivingLicenceResolveValidation;
//# sourceMappingURL=DrivingLicenceResolveValidation.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/validations/DrivingLicenceResolveValidation.js
// module id = 2530
// module chunks = 0